// Development configuration
const isDevelopment = process.env.NODE_ENV === 'development' || 
                     window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1';

export const devConfig = {
  isDevelopment,
  
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    timeout: 30000,
    retryAttempts: 3,
    retryDelay: 1000
  },
  
  // Firebase Configuration
  firebase: {
    enableAppCheck: false, // Disable App Check in development
    enableAnalytics: false, // Disable Analytics in development
    enablePerformance: false // Disable Performance monitoring in development
  },
  
  // Logging Configuration
  logging: {
    level: 'warn', // Reduce console noise in development
    enableDebugLogs: false,
    enablePerformanceLogs: false
  },
  
  // Rate Limiting Configuration
  rateLimiting: {
    enabled: false, // Disable rate limiting in development
    maxRequestsPerMinute: 100,
    maxRequestsPerHour: 1000
  },
  
  // Error Handling
  errorHandling: {
    showDetailedErrors: true,
    enableErrorBoundary: true,
    logErrorsToConsole: true
  }
};

// Development utilities
export const devUtils = {
  // Suppress specific console warnings in development
  suppressWarnings: () => {
    if (isDevelopment) {
      const originalWarn = console.warn;
      console.warn = (...args) => {
        // Suppress specific warnings
        const message = args[0];
        if (typeof message === 'string') {
          if (message.includes('React Router Future Flag Warning')) return;
          if (message.includes('AppCheck: ReCAPTCHA error')) return;
          if (message.includes('Firebase App Check')) return;
        }
        originalWarn.apply(console, args);
      };
    }
  },
  
  // Enable development mode indicators
  enableDevMode: () => {
    if (isDevelopment) {
      console.log('🔧 Development mode enabled');
      console.log('📊 API URL:', devConfig.api.baseUrl);
      console.log('🚫 Rate limiting disabled');
      console.log('🔒 App Check disabled');
    }
  }
};

export default devConfig; 